/*
 * This JS file, is designed to break the dependency between our "analytics.js" and Ensighten,
 * therefore it provides the following:-
 * 1) a listener for the generic "dataBlockLoadEvent" which triggers an Ensighten specific event to read the new
 *  data block "rs.web.digitalData"
 * 2) a listener for the generic "dataBlockCustomPageDataEvent" which triggers an Ensighten specific event to read
 *  the new event block "rs.web.digitalData.events"
 *
 * This has a dependency on jQuery, and is intended to be used in conjunction with "analytics.js"
 */
RS.Modules.EnsightenAnalytics = (function () {
  /* Initialise */
  function init() {
    if (RS.Modules.EnsightenAnalytics.isBootstrapperAvailable()) {
      var _bootstrapper = window.Bootstrapper || {};
      RS.Modules.EnsightenAnalytics.addEventListeners(_bootstrapper);
    }
  }

  /*
   * Add the generic event listeners
   */
  function addEventListeners(bootstrapper) {
    /* Tell ensighten some data was added */
    $(document).on('dataBlockLoadEvent', function () {
      bootstrapper.ensEvent.trigger('reloadDataBlockEvent');
    });

    /* Tell ensighten a new event was added */
    $(document).on('dataBlockCustomPageDataEvent', function () {
      bootstrapper.ensEvent.trigger('customPageDataEvent');
    });
  }

  /*
   * Check is Bootstrapper is loaded
   */
  function isBootstrapperAvailable() {
    return (typeof Bootstrapper === 'object' && Bootstrapper !== null &&
      Bootstrapper.ensEvent && Bootstrapper.ensEvent.trigger);
  }

  /*
   * Make the following methods externally visible
   */
  return {
    init: init,
    addEventListeners: addEventListeners,
    isBootstrapperAvailable: isBootstrapperAvailable,
  };
})();

(function () {
  RS.Modules.EnsightenAnalytics.init();
}());



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/universalheader/ensightenAnalytics.js
// module id = 323
// module chunks = 4